import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { TranslateModule } from '@ngx-translate/core';
import { MultiLoadProfileStatsTableComponent } from './multi-load-profile-stats-table.component';

@NgModule({
  declarations: [MultiLoadProfileStatsTableComponent],
  exports: [MultiLoadProfileStatsTableComponent],
  imports: [CommonModule, TranslateModule, MatTableModule],
})
export class MultiLoadProfileStatsTableModule {}
